import { createGlobalStyle } from "styled-components";
import { theme } from "./theme";
import "../theme/index.css";
import { mediaQuery } from "./constants";

const GlobalStyle = createGlobalStyle`



/* Utilities */

.flex {
  display: flex;
  width: 100%;
}
.inline-flex {
  display: inline-flex;
}
.container {
  width: 100%;  
  max-width: 1500px;
  margin-left: auto;
  margin-right: auto;  
}
.card-hover{
  transition: box-shadow 0.4s;
  :hover {
    box-shadow: hsla(255deg, 0%, 0%, 0.2) -3px 8px 8px 0px;
  }
}
.custom-bullets {
  list-style: none;
  padding: 0;
  margin: 0;
  li {
    display: flex;
    align-items: center;
    gap: 8px;
  }
}
.padding {
  padding-left: 15px;
  padding-right: 15px;  
  @media (min-width: 600px) {
    padding-left: 30px;
     padding-right: 30px;
  }
  @media (min-width: 900px) {
    padding-left: 40px;
     padding-right: 40px;
  }
  @media (min-width: 1200px) {
    padding-left: 60px;
     padding-right: 60px;
  }
}
.col {
  display: flex;
  flex-direction: column;
}
.row {
  display: flex;
  flex-direction: row;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.flex-1 {
  flex: 1;
}
.flex-2 {
  flex: 2;
}
.flex-3 {
  flex: 3;
}
.flex-4 {
  flex: 4;
}
.flex-5 {
  flex: 5;
}
.flex-6 {
  flex: 6;
}
.space-between {
  justify-content: space-between;
}
.space-around {
  justify-content: space-around;
}
.space-evenly {
  justify-content: space-evenly;
}
.justify-center {
  justify-content: center;
}
.justify-end {
  justify-content: flex-end;
}
.align-center {
  align-items: center;
}
.wrap {
  flex-wrap: wrap;
}
.text-center {
  text-align: center;
}
.allCenter {
  justify-content: center;
  align-items: center;
}
.inline-flex {
  display: inline-flex;
}

/* Buttons */

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;  
  padding-left: 28px;
  padding-right: 28px;
  height: 56px;
  border-radius: 28px;
  font-family: "Source sans 3", sans-serif;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 16px;  
  width: fit-content;  
  border: 2px solid ${theme.primary};
  color: ${theme.primary};
  svg {
    margin-left: 10px;
    transition: all 0.2s;
  }
  &:hover svg {
    transform: translateX(5px);
  }
}
.btn.primary {
  background: ${theme.primary};
  color: #fff;
  &:hover {
    transition: all 0.2s ease 0s;
    opacity: 0.92;
  }
}
.btn.terracotta {
  background: none;
  color: rgb(213, 96, 72);
  border: 2px solid rgb(213, 96, 72);
  &:hover {
    transition: all 0.2s ease 0s;
    opacity: 0.92;
  }
}
.btn.terracotta-filled {
  background: rgb(213, 96, 72);
  color: #fff;
  border: 2px solid rgb(213, 96, 72);
  &:hover {
    transition: all 0.2s ease 0s;
    opacity: 0.92;
  }
}
.btn.accent {
  background: ${theme.accent};
  border-color: ${theme.accent};
  color: #fff;
  &:hover {
    transition: all 0.2s ease 0s;
    opacity: 0.92;
  }
}
.btn.secondary {
  background: none; 
  color: ${theme.primary};
}
.btn.white {
  background: #fff; 
  color: ${theme.primary};
}

/* HMTL & Body */

html, body{
  margin: 0;
}

button {
  color: black;
}

*{
  box-sizing: border-box;
}

body {
  font-family: "Open sans", sans-serif;
  color: #000;
}

main {
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Specials */

h1, h2 {  
  u {
    text-decoration: none;
    position: relative;
    z-index: 0;
    &:after {
      content: "";
      position: absolute;
      z-index: -1;
      bottom: 0;
      left: 0;
      height: 0;
      width: 100%;
      
    }
  }
}
h1 {  
  u {
    &:after {
      border-bottom: 12px solid #E9C8C3;      
      bottom: 6px;
    }
    
  }
}
h2 {  
  u {
    &:after {
      border-bottom: 9px solid #E9C8C3;
      bottom: 8px;
      left: -4px;
    }
    
  }
}
/* Fonts */

p,
li {  
  font-size: 17px;
  line-height: 1.6;
}
ul, ol {
    font-size: 18px;
    line-height: 1.6;
}
h1,
h2,
h3 {  
  font-family: "Source sans 3", sans-serif;
  line-height: 1.3;
}
h1 {
    font-size: 36px;
    font-weight: 600;
    @media (max-width: 1200px) {
    }
    @media (max-width: 1000px) {
      font-size: 32px;
    }
    ${mediaQuery.small} {
      font-size: 28px;

    }
}

h2 {
    font-size: 32px;
    font-weight: 600;
    @media (max-width: 800px) {
      font-size: 24px;
    }
}
h3 {
  font-size: 28px;
  font-weight: 600;      
  @media (max-width: 800px) {
      font-size: 20px;
    }
}
p a{
  text-decoration: underline;
}


`;

export default GlobalStyle;
